import {computed, defineComponent, h} from "vue"
import {useDataContext} from "./shared"
import {get} from "lodash"

export default defineComponent({
    name: "DataField",
    props: {
        as: {
            default: 'td'
        },
        name: {
            type: String,
            required: true
        },
        label: String,
        row: Object,
        sortable: {
            type: Boolean,
            default: () => true
        },
        showLabel: {
            type: Boolean,
            default: () => true
        },
        showResponsiveLabel: {
            type: Boolean,
            default: () => true
        }
    },
    setup(props) {
        const api = useDataContext('DataField');

        api.headerProps.value[props.name] = computed(() => ({
            sortable: !!props.name && props.sortable,
            showLabel: props.showLabel,
            showResponsiveLabel: props.showResponsiveLabel,
        }))
    },
    render() {
        return h(this.as, {}, this.$slots.default ? this.$slots.default(this) : get(this.row, this.name));
    },
});
